import React, { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from './features/Home/Home';
import Page from './features/Page/Page';
import './index.css';

import { wordpressRoot } from './configFile';
import Footer from './features/Footer/Footer';
import Header from './features/Header/Header';
import * as serviceWorker from './serviceWorker';
import Article from './features/Article/Article';

export default function Index() {

  useEffect(() => {
    const expires = localStorage.getItem('expires')
    if (expires == null) {
      const newExpires = Date.now() + minutesToMillis(60)
      localStorage.setItem('expires', newExpires)
    } else {
      removeIfExpires(expires)
    }
  }, [])

  const removeIfExpires = (expires) => {
    if (expires < Date.now()) {
      localStorage.removeItem('homepage')
      localStorage.removeItem('Posts')
      localStorage.removeItem('EmbeddedPosts')
      localStorage.removeItem('expires')
    }
  }

  const minutesToMillis = (minutes) => {
    return minutes * 60 * 1000
  }

  return (
    <React.StrictMode>
      <BrowserRouter basename={wordpressRoot}>
        <Header />
        <Routes>
          <Route path='' element={<Home />} />
          <Route path="/article/:postName" element={<Article />} />
          <Route path="/:pageName" element={<Page />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </React.StrictMode>
  )
}

const root = createRoot(document.getElementById('root'));
root.render(<Index />);



// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
